<template>
  <div class="submit-container" v-if="start">
    <p>Submit selected fund changes to production ({{fundsNumber}})</p>
    <p>
      Fund Status Changes ({{data.statusChanges}})
      <br />
      Fund Series Changes ({{data.seriesChanges}})
      <br />
      Fund Category Changes ({{data.categoryChanges}})
    </p>
    <div class="submit-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" class="submit-button" @click="doSubmit"> Submit to Production </mds-button>
    </div>
  </div>
  <div class="submit-container progress" v-else>
    <loader-spinner />
    <p class="submit-process-text">Submitting to Production</p>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
import ErrorNotificationMixin from '@/mixins/ErrorNotificationMixin';
import * as SubmitChangesService from '@/services/SubmitChanges';

export default {
  name: 'submit-changes',
  components: {
    LoaderSpinner,
  },
  mixins: [
    ErrorNotificationMixin({ component: 'SubmitChanges' }),
  ],
  data() {
    return {
      start: true,
      request: null,
      requestController: null,
      requestUrl: null,
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    doSubmit() {
      this.start = false;
      const payload = {
        fiduciaryFundIds: this.data.selectedFunds,
      };
      SubmitChangesService.submitFundStatusChangesToProduction({
        selectedFiduciary: this.fiduciaryId,
        payload,
      }).then((result) => {
        this.closeModal(result);
        if (result.status.success) {
          // force the grid to reload
          this.$store.dispatch('setReloadNeed', true);
          this.$store.dispatch('openNotification', {
            title: 'Updates Successfully Submitted',
            message: `${this.fundsNumber} changes have been submitted to production`,
          });
        }
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
        if (httpStatus === 401) {
          this.$router.push('/Login');
        } else if (error.message && error.message !== 'AbortError') {
          this.notifyError({
            error,
            section: 'methods:loadData',
            data: { url: this.requestUrl },
            notificaction: {
              title: 'Pending Fund Changes Grid',
              message: `Fetching Data (Error: ${error.message})`,
            },
          });
        }
        return false;
      });
    },
  },
  computed: {
    ...mapState({
      fiduciaryId: (state) => state.user.fiduciary.id,
    }),
    fundsNumber() {
      return this.data.selectedFunds.length;
    },
  },
};
</script>
<style lang="scss">
.submit-container {
  @include mds-body-text-m();
  p {
    padding-bottom: $mds-space-1-and-a-half-x;
  }
  p:nth-child(2) {
    margin-bottom: 45px;
  }
  .submit-process-text {
    text-align: center;
  }
  .submit-actions {
    button:not(:first-child) {
      margin-left: $mds-space-1-and-a-half-x;
    }
  }
}
</style>
